export default [
  {
    name: "orderstore_index_stat",
    path: "/offline-stores/stats",
    component: () => import("../pages/global/syncunion/statistics.vue"),
  },
  {
    name: "orderstore_index",
    path: "/offline-stores/order",
    component: () => import("../pages/union/order/index.vue"),
  },
  {
    name: "promobank_list",
    path: "/offline-stores/promo-bank",
    component: () => import("../pages/union/promo-bank/index.vue"),
  },
  {
    name: "promobank_create",
    path: "/offline-stores/promo-bank/create",
    component: () => import("../pages/union/promo-bank/manage.vue"),
  },
  {
    name: "promobank_update",
    path: "/offline-stores/promo-bank/update/:id",
    component: () => import("../pages/union/promo-bank/manage.vue"),
  },
  {
    name: "tokovouchers_list",
    path: "/offline-stores/vouchers",
    component: () => import("../pages/union/vouchers/index.vue"),
  },
  {
    name: "tokovouchers_update",
    path: "/offline-stores/vouchers/update/:id",
    component: () => import("../pages/union/vouchers/update.vue"),
  },
  {
    name: "stamp_list",
    path: "/offline-stores/stamp",
    component: () => import("../pages/union/stamp/index.vue"),
  },
  {
    name: "synctoko_index",
    path: "/offline-stores/sync-monitoring",
    component: () => import("../pages/union/monitoring/sync-progress.vue"),
    // component: () => import("../pages/union/monitoring/index.vue"),
    // component: () => import("../pages/global/syncunion/index.vue"),
  },
  {
    name: "storelocw_index",
    path: "/offline-stores/store",
    component: () => import("../pages/website/store/index.vue"),
  },
  {
    name: "storelocw_create",
    path: "/offline-stores/store/create",
    component: () => import("../pages/website/store/manage.vue"),
  },
  {
    name: "storelocw_update",
    path: "/offline-stores/store/update/:id",
    component: () => import("../pages/website/store/manage.vue"),
  },
  {
    name: "promotionpos_index",
    path: "/offline-stores/promotion",
    component: () => import("../pages/union/promotions/index.vue"),
  },
  {
    name: "promotionpos_create",
    path: "/offline-stores/promotion/create",
    component: () => import("../pages/union/promotions/create.vue"),
  },
  {
    name: "promotionpos_edit",
    path: "/offline-stores/promotion/edit/:id",
    component: () => import("../pages/union/promotions/create.vue"),
    props: true,
  },
  {
    name: "promotionpos_releases",
    path: "/offline-stores/promotion/releases",
    component: () => import("../pages/union/promotions/releases/index.vue"),
  },
  {
    name: "promotionpos_sync",
    path: "/offline-stores/promotion/sync",
    component: () => import("../pages/union/promotions/sync/index.vue"),
  },

  // Penyiapan Token Approver Diskon (P26_0031 AC-08.2) — halaman khusus IT.
  // Nama route = alias modul `spgtoken_index`, didaftarkan lewat migration
  // 2026_08_20_150000_insert_spg_token_modules.
  {
    name: "spgtoken_index",
    path: "/offline-stores/spg-token",
    component: () => import("../pages/union/spg-token/index.vue"),
  },

  // Pemantauan Penugasan SPG Eksternal (P26_0031 AC-08.4).
  // Nama route = alias modul `spgexternal_index`, didaftarkan lewat migration
  // 2026_08_27_120000_insert_spg_external_modules.
  {
    name: "spgexternal_index",
    path: "/offline-stores/spg-external",
    component: () => import("../pages/union/spg-external/index.vue"),
  },

  // Panel Pantau Stok di Pusat (P26_0035 FR-10). Nama route = alias modul
  // `posstock_index` (migrasi 2026_09_28_120000_insert_pos_stock_modules). Detail
  // memakai grup yang sama (`posstock`), jadi akses sidebar-nya ikut.
  {
    name: "posstock_index",
    path: "/offline-stores/pos-stock",
    component: () => import("../pages/union/pos-stock/index.vue"),
  },
  {
    name: "posstock_movement",
    path: "/offline-stores/pos-stock/detail",
    component: () => import("../pages/union/pos-stock/detail.vue"),
  },

  // Pemantauan Penerimaan (P26_0035 FR-16). Nama route = alias modul
  // `posreceipt_index` (didaftarkan lewat menu Modules).
  {
    name: "posreceipt_index",
    path: "/offline-stores/pos-receipt",
    component: () => import("../pages/union/pos-receipt/index.vue"),
  },

  // Batas Waktu Penerimaan Inventori (P26_0035 FR-11). Nama route = alias modul
  // `receiptsla_index` (didaftarkan lewat menu Modules).
  {
    name: "receiptsla_index",
    path: "/offline-stores/receipt-sla",
    component: () => import("../pages/union/receipt-sla/index.vue"),
  },

  // Master Product — katalog SAP vs katalog POS. Nama route = alias modul
  // `masterproduct_index` (migrasi 2026_10_20_120002_insert_master_product_modules).
  {
    name: "masterproduct_index",
    path: "/offline-stores/master-product",
    component: () => import("../pages/union/master-product/index.vue"),
  },

  // Pengaturan Brand (P26_045 FR-01). Nama route = alias modul `brandsetting_index`
  // (migrasi 2026_10_20_120000_insert_pos_brand_settings_modules).
  {
    name: "brandsetting_index",
    path: "/offline-stores/brand-settings",
    component: () => import("../pages/union/brand-settings/index.vue"),
  },

  // Persetujuan Retur (P26_045 FR-07). Nama route = alias modul `posreturn_index`
  // (migrasi 2026_10_20_120001_insert_pos_return_approval_modules).
  {
    name: "posreturn_index",
    path: "/offline-stores/pos-return",
    component: () => import("../pages/union/pos-return/index.vue"),
  },

  // Penjadwalan Master Produk (OITM Master Versioning)
  {
    name: "oitmmaster_index",
    path: "/offline-stores/oitm-master",
    component: () => import("../pages/union/oitm-master/Draft.vue"),
  },
  {
    name: "oitmmaster_publish_preview",
    path: "/offline-stores/oitm-master/publish-preview",
    component: () => import("../pages/union/oitm-master/PublishReview.vue"),
  },
  {
    name: "oitmmaster_releases",
    path: "/offline-stores/oitm-master/releases",
    component: () => import("../pages/union/oitm-master/Releases.vue"),
  },
  {
    name: "oitmmaster_calendar",
    path: "/offline-stores/oitm-master/calendar",
    component: () => import("../pages/union/oitm-master/Calendar.vue"),
  },

];


